export const PATHNAMES = [
  {
    ua: `refugee-guide`,
    lt: `informacija-ukrainieciams`,
  },
  {
    ua: `help-search`,
    lt: `pagalbos-paieska`,
  },
  {
    ua: `privacy-policy`,
    lt: `privatumo-politika`,
  },
];
